import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const setChangePasswordWidgetCurrentPassword = createAction(
  `${reduxKey}.SET_CHANGEPASSWORD_WIDGET_CURRENT_PASSWORD`,
  (currentPassword: string) => ({ currentPassword })
);

export const setChangePasswordWidgetNewPassword = createAction(
  `${reduxKey}.SET_CHANGEPASSWORD_WIDGET_NEW_PASSWORD`,
  (newPassword: string) => ({ newPassword })
);

export const setChangePasswordWidgetNewPasswordRepeat = createAction(
  `${reduxKey}.SET_CHANGEPASSWORD_WIDGET_NEW_PASSWORD_REPEAT`,
  (newPasswordRepeat: string) => ({ newPasswordRepeat })
);

export const saveChangePassword = createAction(
  `${reduxKey}.SAVE_CHANGE_PASSWORD`,
  () => ({})
);

export const saveChangePasswordSuccess = createAction(
  `${reduxKey}.SAVE_CHANGE_PASSWORD_SUCCESS`,
  () => ({})
);

export const saveChangePasswordFailure = createAction(
  `${reduxKey}.SAVE_CHANGE_PASSWORD_FAILURE`,
  (errorMessage: string) => ({ errorMessage })
);
